<template>
  <div
    :class="{
      'price-rows-savings-fi': true,
      'price-rows-savings-fi--mobile': mobile,
    }"
  >
    <div
      v-if="mobile"
      class="price-rows-savings-fi__label"
    >
      {{ $dict.get('online-Shop.Product.Price-Rows-Savings') }}
    </div>

    <div
      v-for="(item, index) in savings"
      :key="index"
      :class="{
        'price-rows-savings-fi__row': true,
        'price-rows-savings-fi__row--active': item.active,
      }"
      @click="mobile ? null : rowClicked(item)"
    >
      <div class="price-rows-savings-fi__qtd">
        <template v-if="index === 0"> {{ item.minQty }} {{ prefix(item.unit) }} </template>
        <template v-else>
          {{
            $dict.get('online-Shop.Product.Price-Rows-Quantity-Label', [
              `${item.minQty} ${prefix(item.unit)}`,
            ])
          }}
        </template>
      </div>
      <div class="price-rows-savings-fi__price">
        <strong data-test="price-rows-price">{{ item.valueFormatted }}</strong>
        <span class="price-rows-savings-fi__price-prefix"
          >/ {{ item.priceQty !== 1 ? item.priceQty : null }} {{ prefix(item.unit) }}</span
        >
      </div>
      <div class="price-rows-savings-fi__saving">
        <span
          v-if="isSaving(item)"
          data-test="price-rows-saving"
          class="price-rows-savings-fi__saving__saving badge-fi"
        >
          {{
            $dict.get('online-Shop.Product.Price-Rows-Saving-Label', [
              item.savingsInformation.savingsInPercent,
            ])
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import sellingUnitMixin from 'mixins/sellingUnitMixin';

export default {
  name: 'PriceRowsSavingsFi',
  mixins: [sellingUnitMixin],
  props: {
    savings: {
      type: Array,
      default: () => [],
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['clicked'],
  computed: {
    currency() {
      return this.savings.currency;
    },
  },
  methods: {
    prefix(unit) {
      return unit?.code ? this.getSellingUnit(unit.code) : this.getSellingUnit('ST');
    },
    isSaving(item) {
      return item.savingsInformation?.savingsInPercent;
    },
    rowClicked(item) {
      this.$emit('clicked', item);
    },
  },
};
</script>

<style scoped lang="scss">
@import './price-rows-savings-fi';
</style>
